module.exports = __webpack_public_path__ + "static/media/spcportal_thumbnail.5e80f7a6.png";